export default "__VITE_ASSET__BZh0sGFB__"